module.exports = __webpack_public_path__ + "static/Molendini-6b8012c59a42a679a462f955e234753d.gif";